// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2Ld0t","requiredAsterisk":"Info_requiredAsterisk__1jwgn"};